module.exports = __webpack_public_path__ + "img/home.9249859d.png";